import { useGetApiV1UserProfile } from '@services/identity-api/orval-api/user-api/user-api';

export function useUserProfile() {
  const { data, isPending } = useGetApiV1UserProfile({
    query: { staleTime: 60 * 1000, retry: 10 },
  });

  return {
    userProfile: data,
    userProfileIsPending: isPending,
  };
}
